import BaseScript from "../ScriptEngine/ScriptTypes";
import { ScriptDescriptionType } from "../Types";
import BaseViewModel, { BaseViewModelParams } from "./BaseViewModel";

class DictionaryRegistryControlViewModel extends BaseViewModel {

	multiflag: boolean;
	options: Array<any> = [];
	metaData: Array<any> = [];
	// идентификатор внешнего справочника
	DictionaryId?: string;
	// идентификатор справочника-родителя
	ParentId?: string;
	DictionarySource?: string;
	nullTitle?: string;
	ExternalRequest?: string;
	DisplayFieldScript: any;
	getParentIdScript: BaseScript | null = null;
	selectedValueS2: any;
	isSave: boolean;

	/** URL запроса справочника */
	dataUrl: string = "/DynamicForm/GetDictionaryRegistryData";
	/** Ключ внешнего справочника */
	dataParent: any;
	dataDict?: string;

	constructor ( params: BaseViewModelParams ) {
		super( params );
		this.multiflag = params.elementDescriptor.ControlKey === "CheckComboBox" ? true : false;
		this.isSave = !!params.elementDescriptor.IsSave;
		this.nullTitle = params.elementDescriptor.NullTitle;
		this.ExternalRequest = params.elementDescriptor.ExternalRequest;
		this.DictionaryId = params.elementDescriptor.DictionaryId
		this.ParentId = params.elementDescriptor.ParentId;
		this.DictionarySource = params.elementDescriptor.DictionarySource;
		this.dataParent = params.elementDescriptor.ParentId;
		this.dataDict = params.elementDescriptor.DictionaryId;

		if ( params.elementDescriptor.DictionarySource?.startsWith('Dictionary') || params.elementDescriptor.DictionarySource?.startsWith('IDictionary') ) {
			//это справочник внешний, или основанный на адаптере справочников IDictionary
		}
		else if ( params.elementDescriptor.DictionarySource?.startsWith('Context') ) {
			// это переменная контекста
			this.dataParent = params.elementDescriptor.DisplayFieldScript;
			this.dataDict = params.elementDescriptor.DictionarySource;
			this.dataUrl = "/DynamicForm/GetDictionaryRegistryContextData";
		} 
		else if ( params.elementDescriptor.DictionarySource?.startsWith('Entity') ) {
			this.dataUrl = "/DynamicForm/GetDictionaryRepositoryData";
			this.dataDict = params.elementDescriptor.DictionarySource;
		} 
		else {
			this.dataUrl = "/DynamicForm/GetDictionaryRegistryViewModelData";
			this.dataParent = params.elementDescriptor.DisplayFieldScript;
		}
	};

	setValue = ( value: any ) => {
		let val: string | string[] | undefined = undefined;
		if ( value ) {
			if ( Array.isArray(value) ) {
				val = value.map( v => v.toString() );
			}
			else {
 				val = value.toString();
			}
		}
		this.selectedValueS2 = val;
		this.Value = val;
		// синхронно обновляем metaData из уже загруженных options, чтобы зависимые EnumTitle-скрипты отрабатывали правильно
		if ( val != null && this.options?.length ) {
			const item = this.options.find( (x: any) => String(x.id ?? '') === String(val) );
			if ( item ) this.metaData = [item];
		}
	};
	getValue = () => this.selectedValueS2;

	ValidateMandatory = () => {
		return !this.IsMandatory || !!this.Value || ( !!this.selectedValueS2 && this.selectedValueS2.length > 0 );
	};

	getParentIdFunc = () => {
		if ( BaseViewModel.isClientScripts !== false ) {
			if ( this.getParentIdScript === null )
				this.fillGetParentIdScript();
			if ( this.getParentIdScript !== null )
				return this.getParentIdScript.runScript();
		}
		return this.dataParent;
	};

	fillGetParentIdScript = () => {
		const scriptDescr: ScriptDescriptionType = {
			ScriptType: "JavaScript",
			Content: "hostObject.GetValue(\"" + this.ParentId + "\")"
		};
		this.getParentIdScript = ( !!this.ParentId && !!BaseViewModel.mediator ) ? BaseViewModel.mediator.createScriptObject(this, scriptDescr, "") : null;
	};
};

export default DictionaryRegistryControlViewModel;
